import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  {
    title: '一、服务说明',
    content: `欢迎使用寻御科技（上海）有限公司（以下简称"本公司"、"我们"）提供的工业双碳数字化及AI智能化服务平台（以下简称"本平台"）。

本服务条款（以下简称"本条款"）是您与本公司之间关于使用本平台产品及服务的法律协议。请您在使用本平台前仔细阅读本条款。一旦您注册、登录或使用本平台，即表示您已阅读、理解并同意接受本条款的约束。

本平台主要为B端企业用户提供以下服务：
• 工信部碳排放申报管理服务
• 工业AI智能化解决方案
• CCER/CBAM合规填报与数据上报服务
• 企业碳台账区块链存证服务
• 工业能耗AI监测分析服务
• 相关增值配套服务`,
  },
  {
    title: '二、账户注册与安全',
    content: `**账户注册**：您需要提供真实、准确、完整的企业信息进行注册。您对所提供信息的真实性负责，并承诺及时更新信息以保持准确性。

**账户安全**：您有责任保管账户密码，对以您账户进行的所有活动负责。如发现任何未经授权使用您账户的情况，请立即通知我们。

**账户使用**：禁止将账户转让、出租或以任何方式提供给第三方使用。每个账户仅限注册主体使用，违者我们有权暂停或终止服务。

**实名认证**：企业账户需完成企业资质认证，提供营业执照等相关证明材料。`,
  },
  {
    title: '三、服务使用规范',
    content: `使用本平台时，您承诺遵守以下规范：

• 遵守中华人民共和国相关法律法规及行业规范；
• 不上传、发布或传播违法、虚假、误导性信息；
• 不对平台进行逆向工程、反编译或破解；
• 不尝试未经授权访问系统或数据；
• 不干扰或破坏平台正常运行；
• 确保上传的企业数据真实、准确，对数据真实性负责；
• 不利用本平台从事任何违法或侵权活动；
• 尊重其他用户的合法权益。

违反上述规范，我们有权暂停或终止您的服务，并保留追究法律责任的权利。`,
  },
  {
    title: '四、数据权属与授权',
    content: `**您的数据**：您上传至平台的企业能耗数据、碳排放数据等业务数据，其所有权归您所有。您授予本公司在提供服务所必要范围内使用上述数据的权利。

**平台数据**：平台本身的软件、算法、模型、界面设计、文档等均属本公司知识产权，未经授权不得复制、修改或分发。

**数据安全承诺**：我们采用行业标准安全措施保护您的数据，详见隐私政策。服务终止后，我们将按约定或法律规定处理您的数据。

**匿名化使用**：我们可能将脱敏、匿名化处理后的行业统计数据用于研究、报告或产品改进，不涉及任何可识别您的信息。`,
  },
  {
    title: '五、付款与退款',
    content: `**付款方式**：本平台采用合同制收费模式，具体费用以双方签订的服务合同为准。支持银行转账、对公付款等企业支付方式。

**发票**：我们提供增值税专用发票，请在付款后通过合同约定方式申请开具。

**退款政策**：
• 服务尚未开始交付前，已付款项可申请全额退款；
• 服务部分交付后，退款金额按未交付部分比例核算；
• 因我们原因导致服务无法交付，全额退款；
• 因您方原因提前终止服务，退款按合同约定执行。

**价格调整**：我们保留合理调整服务价格的权利，价格调整不影响已签署合同的履行。`,
  },
  {
    title: '六、服务水平与承诺',
    content: `**系统可用性**：我们承诺平台服务可用性不低于 99.5%（不含计划维护时间）。

**数据准确性**：碳排放核算模块的计算准确率不低于 99.5%，以工信部认可的核算方法学为准。

**技术支持**：提供工作日 9:00-18:00 的在线技术支持，紧急故障提供 7×24 响应。

**服务变更通知**：如需对服务内容进行重大调整，我们将提前 30 天通知您。

**免责情形**：因不可抗力（包括但不限于自然灾害、政府行为、网络基础设施故障等）导致的服务中断，本公司不承担责任，但将尽力减少损失并及时恢复服务。`,
  },
  {
    title: '七、知识产权',
    content: `• 本平台的软件代码、算法模型、界面设计、文档资料、商标标识等，均属本公司或其许可方的知识产权，受中国及国际知识产权法律保护；
• 未经本公司书面授权，您不得复制、修改、传播、销售、出租或以其他方式使用上述内容；
• 您对上传至平台的内容拥有知识产权，并保证上传内容不侵犯第三方权利；
• 如发现任何知识产权侵权行为，请及时联系我们，我们将依法处理。`,
  },
  {
    title: '八、责任限制',
    content: `在法律允许的最大范围内：

• 本公司对因使用或无法使用本平台而导致的间接、特殊、附带或惩罚性损失不承担责任；
• 在任何情况下，本公司的最大赔偿责任不超过您在事件发生前 12 个月内实际支付给本公司的服务费用；
• 本公司对第三方提供的数据、内容或服务的准确性、完整性不作保证；
• 本条款中的责任限制不适用于本公司的故意行为或重大过失。`,
  },
  {
    title: '九、条款修改',
    content: `我们保留随时修改本条款的权利。重大修改将通过以下方式通知您：

• 平台内站内信或公告；
• 注册邮箱推送通知；
• 登录时弹窗提示。

修改后继续使用本平台，视为接受修订后的条款。如不接受修改，您应停止使用服务并联系我们办理退出手续。`,
  },
  {
    title: '十、争议解决',
    content: `• 本条款的签订、履行、解释及争议解决均适用中华人民共和国法律；
• 如发生争议，双方应首先友好协商解决；
• 协商不成的，任何一方均可向本公司所在地（上海市虹口区）有管辖权的人民法院提起诉讼；
• 本条款中任何条款被认定无效，不影响其他条款的效力。

如有任何疑问，请联系我们：
• **邮箱**：info@xunyutech.cn
• **电话**：18916035855
• **地址**：上海市虹口区水电路1388号`,
  },
];

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-firmai-dark">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-12 bg-firmai-darker overflow-hidden">
          <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-firmai-green/6 rounded-full blur-3xl pointer-events-none" />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-3xl mx-auto">
              <nav className="flex items-center gap-2 text-xs text-firmai-muted mb-6">
                <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="hover:text-firmai-green transition-colors cursor-pointer">首页</a>
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-s-line" /></span>
                <span className="text-firmai-text">服务条款</span>
              </nav>
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-firmai-green/10 border border-firmai-green/25 text-firmai-green text-xs font-semibold mb-4">
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-file-text-line" /></span>
                法律文件
              </span>
              <h1 className="font-display font-bold text-3xl md:text-4xl text-white mb-4">服务条款</h1>
              <p className="text-firmai-text text-sm leading-relaxed">
                最后更新日期：2026年1月1日 &nbsp;·&nbsp; 生效日期：2026年1月1日
              </p>
              <p className="text-firmai-muted text-sm mt-3 leading-relaxed max-w-2xl">
                请仔细阅读本服务条款。使用寻御科技平台即表示您同意受本条款约束。如有任何问题，请在使用前联系我们。
              </p>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-14 bg-firmai-dark">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-3xl mx-auto">
              <div className="space-y-10">
                {sections.map((sec) => (
                  <div key={sec.title} className="bg-firmai-card border border-firmai-border rounded-xl p-6 md:p-8">
                    <h2 className="text-white font-bold text-base md:text-lg mb-4 flex items-center gap-2">
                      <span className="w-1 h-5 bg-firmai-green rounded-full inline-block shrink-0" />
                      {sec.title}
                    </h2>
                    <div className="text-firmai-text text-sm leading-relaxed">
                      {sec.content.split('\n').map((line, i) => {
                        if (line.startsWith('• **') && line.includes('**')) {
                          const match = line.match(/^• \*\*(.+?)\*\*：?(.*)$/);
                          if (match) {
                            return (
                              <p key={i} className="mb-2 pl-3">
                                <span className="text-firmai-green font-semibold">{match[1]}</span>
                                {match[2] ? <span>：{match[2]}</span> : null}
                              </p>
                            );
                          }
                        }
                        if (line.startsWith('• ')) {
                          return <p key={i} className="mb-2 pl-3 flex items-start gap-2"><span className="text-firmai-green mt-1.5 shrink-0">·</span>{line.replace('• ', '')}</p>;
                        }
                        if (line.startsWith('**') && line.endsWith('**')) {
                          return <p key={i} className="mb-2 text-white font-semibold">{line.replace(/\*\*/g, '')}</p>;
                        }
                        if (line === '') return <div key={i} className="h-2" />;
                        return <p key={i} className="mb-2">{line}</p>;
                      })}
                    </div>
                  </div>
                ))}
              </div>

              {/* Bottom nav */}
              <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-firmai-border">
                <div className="flex items-center gap-4 text-sm">
                  <a href="/privacy" onClick={(e) => { e.preventDefault(); navigate('/privacy'); }} className="text-firmai-muted hover:text-firmai-green transition-colors cursor-pointer">隐私政策</a>
                  <span className="text-firmai-border">|</span>
                  <a href="/copyright" onClick={(e) => { e.preventDefault(); navigate('/copyright'); }} className="text-firmai-muted hover:text-firmai-green transition-colors cursor-pointer">版权声明</a>
                </div>
                <a
                  href="/contact"
                  onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-firmai-green text-firmai-dark font-semibold rounded-md hover:bg-firmai-green/90 transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
                >
                  联系我们
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}